module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vleg11-8f6c151d2918f4426b1b1c3ae6fbfb3d.jpg";